((scope)=>{
  const calculate=(p,input)=>{
    const o=p.options[Number(input.option||0)];if(!o)throw Error('Choose an available option.');
    const pos=n=>Number.isFinite(Number(n))&&Number(n)>0&&Number(n)<=10000;
    let qty=Number(input.quantity||1),description=o.label;
    if(p.coverage){
      if(!pos(input.length)||!pos(input.width))throw Error('Enter a valid room length and width.');
      const area=Number(input.length)*Number(input.width)*(input.units==='ft'?.09290304:1);
      qty=Math.ceil(area*(1+Number(p.waste||0)/100)/p.coverage-1e-10);
      if(!Number.isSafeInteger(qty)||qty>10000)throw Error('Please contact us to quote an area this large.');
      description+=`; ${input.length} × ${input.width} ${input.units}; ${area.toFixed(2)}m²; ${p.waste||0}% cutting allowance; ${qty} whole boxes; supply only`;
    }else if(p.rollCut){
      if(!pos(input.length)||!pos(o.rollWidth))throw Error('Enter a valid cut length.');
      qty=o.rollWidth*Number(input.length);description+=`; ${o.rollWidth}m × ${input.length}m cut; ${qty.toFixed(2)}m²; supply only`;
    }else{
      if(!pos(qty)||(p.unit==='item'||p.unit==='box')&&!Number.isInteger(qty))throw Error('Enter a valid quantity.');
      description+=`; quantity ${qty} ${p.unit||'item'}`;
    }
    const drawers=Number(input.drawers||0);
    if(p.drawers&&(!Number.isInteger(drawers)||drawers<0||drawers>(o.maxDrawers||4)))throw Error('Choose an available number of drawers.');
    const extraIds=Array.isArray(input.extras)?[...new Set(input.extras)]:[];
    const extras=extraIds.map(i=>p.extras?.[i]);if(extras.some(x=>!x))throw Error('Choose an available extra.');
    let total=o.price===null?null:Math.round(qty*(o.price+(p.drawers?drawers*35:0)+extras.reduce((s,x)=>s+x.price,0))*100)/100;
    if(total!==null&&(!Number.isFinite(total)||total<=0))throw Error('This option needs an individual quote.');
    if(p.drawers)description+=`; ${drawers} drawers per bed`;
    if(p.fabric)description+=`; fabric / colour: ${String(input.fabric||'').trim()}`;
    extras.forEach(x=>description+='; '+x.label+' per item');
    description+='; '+p.notes+(input.notes?'\nCustomer notes: '+String(input.notes).slice(0,1000):'');
    return {title:p.title,details:description,total,deliveryIncluded:!!o.deliveryIncluded,collectionOnly:!!o.collectionOnly,roiOnly:!!p.roiOnly,quantity:qty};
  };
  const subtotal=lines=>lines.reduce((s,l)=>s+(l.total===null?0:Math.round(l.total*100)),0)/100;
  if(typeof module!=='undefined'&&module.exports)module.exports={calculate,subtotal};else scope.McGinleySiteModel={calculate,subtotal};
})(typeof globalThis!=='undefined'?globalThis:this);